import { createContext } from "react";
import { PageContent } from "./Types";
export const PreviewContext = createContext<{
  footer?: Partial<PageContent>;
  navigation?: PageContent["navigation"];
  preview?: boolean;
}>({});
